(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.producte')
    .factory('ProducteFactory', ProducteFactory);
  function ProducteFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'productes';

    var ProducteBase = {
      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },
      getProductesEntitats:function(){
        var url = api + '/productesentitats';
        return DataFactory.get(url);
      },
      get: function(id){
        var url = api + '/' + id;
        return DataFactory.get(url);
      },
      add: function(obj){
        return DataFactory.add(api,obj);
      },
      duplicate: function(obj){
        return DataFactory.add(api+'/duplicate',obj);
      },
      update: function(id, obj){
        var url = api + '/' + id;
        return DataFactory.update(url,obj);
      },
      delete: function(id){
        var url = api;
        return DataFactory.delete(url, id);
      },
      gettemesvistesarrel: function(idproducte){
        var url = api +'/temesvistesarrel' ;
        return DataFactory.getWithParams(url, {"idproducte":idproducte});
      },
      getfills: function(id,idproducte){
        var url = api + '/' + id + '/fills';
        return DataFactory.getWithParams(url, {"idproducte":idproducte});
      },
      updatevistes: function(id, obj){
        var url = api + '/' + id + '/vistes';
        return DataFactory.update(url,obj);
      },
      updaterols: function(id, obj){
        var url = api + '/' + id + '/updaterols';
        return DataFactory.update(url);
      },
      getProducteEntitats: function(id,form){
        var url = api + '/' + id + '/entitats' ;
        return DataFactory.getWithParams(url, form);
      },
    };
    return ProducteBase;
  }
}());
